import { getMyChancesObject } from 'modules/FinalList/constants';

export const SCATTERGRAM_MIN_POINTS_COUNT = 5;
export const SCATTERGRAM_INCOMPLETE_GPA_MIN_POINTS_COUNT = 1;

export const DISTRICT_DISTANCE_KEY = 'order_by_district_distance';
export const EFC_KEY = 'efc';
export const US_NEWS_RANKING_KEY = 'us_news_ranking';

export const DEFAULT_ACCEPTANCE_RATE = [0, 100];

export const ALUMNI_UNWEIGHTED_GPA = 'alumniUnweightedGpa';
export const ALUMNI_WEIGHTED_GPA = 'alumniWeightedGpa';
export const SCATTERGRAM_CLASS_YEARS_COUNT = 4;

export const ADMISSIONS_ARTICLE_LINK =
  'https://support.schoolinks.com/en/articles/9083815-student-admissions-filter-in-school-search';

export const CHANCES_ICONS = getMyChancesObject({ iconColor: 'grayDark' });

export const FOUR_YEARS_GRADUATION_RATE_SORT_KEY = 'graduation_rate';
export const SIX_YEARS_GRADUATION_RATE_SORT_KEY = 'graduation_rate_150';
export const EIGHT_YEARS_GRADUATION_RATE_SORT_KEY = 'graduation_rate_200';
